export default "__VITE_ASSET__BKWbAQcA__"